import { render, staticRenderFns } from "./itemGroupTwo.vue?vue&type=template&id=6f7cfd89"
import script from "./itemGroupTwo.vue?vue&type=script&lang=js"
export * from "./itemGroupTwo.vue?vue&type=script&lang=js"
import style0 from "./itemGroupTwo.vue?vue&type=style&index=0&id=6f7cfd89&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports